<h2 mat-dialog-title>Description</h2>
<button type="button" class="btn btn-link modal-close" (click)="cancel()">
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="#03101F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
<mat-dialog-content>
 <div>
    <p class="font-normal fs-14">{{ description }}</p>
 </div>
</mat-dialog-content>
